var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessGreenRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#success-green-round_svg__clip0_1657_72544)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.988,
    cy: 24.021,
    r: 23.2,
    fill: "#4DBC9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.388 20.021l-8.8 8.8-4-4",
    stroke: "#fff",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "success-green-round_svg__clip0_1657_72544"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.988 .021)",
    d: "M0 0h48v48H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDkiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OSA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE2NTdfNzI1NDQpIj4KPGNpcmNsZSBjeD0iMjQuOTg3OCIgY3k9IjI0LjAyMTMiIHI9IjIzLjIiIGZpbGw9IiM0REJDOUIiLz4KPHBhdGggZD0iTTMxLjM4NzggMjAuMDIxNEwyMi41ODc4IDI4LjgyMTRMMTguNTg3OCAyNC44MjE0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTY1N183MjU0NCI+CjxyZWN0IHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTg3NzkzIDAuMDIxNDg0NCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgSuccessGreenRound as ReactComponent };